/**
 * Buffer allocation utilities - extracted to break circular dependency
 * between convert.ts and BufferGeometryAllocator.ts
 */
import { BufferAttribute, BufferGeometry } from "three";

export function allocateMultiPolyLine2ToTHREEStrokeBuffers(
  maxVertexCount: number,
  maxTriCount: number,
): BufferGeometry {
  const positionArray = new Float32Array(maxVertexCount * 3);
  const normalArray = new Float32Array(maxVertexCount * 3);
  const texArray = new Float32Array(maxVertexCount);
  const distArray = new Float32Array(maxVertexCount);
  const triArray = new Uint32Array(maxTriCount);
  const idArray = new Float32Array(maxVertexCount * 4);

  const g = new BufferGeometry();
  g.setAttribute("position", new BufferAttribute(positionArray, 3));
  g.setAttribute("normal", new BufferAttribute(normalArray, 3));
  g.setAttribute("texOffset", new BufferAttribute(texArray, 1));
  g.setAttribute("distance", new BufferAttribute(distArray, 1));
  g.setAttribute("id", new BufferAttribute(idArray, 4));
  g.setIndex(new BufferAttribute(triArray, 1));
  g.setDrawRange(0, 0);

  return g;
}
